<template>
  <div>
    <div class="page-header pr-0">
      <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
      <ol class="breadcrumbs">
          <li class="active">
            <span>SIRE <el-tooltip class="item"
                        content="Sistema Integrado de Registros Electrónicos"
                        effect="dark"
                        placement="top-start">
                <i class="fa fa-info-circle"></i>
            </el-tooltip>
             - {{ type === 'sale' ? 'Ventas' : 'Compras' }}
            </span>
            
          </li>
      </ol>
    </div>
    <div class="card mt-3">
      <div class="card-body border-bottom">
        <el-form :inline="true" :model="form" class="demo-form-inline mb-0">
          <el-form-item label="Año" class="label-mt-0">
            <el-select v-model="form.year" @change="setPeriods()">
              <el-option v-for="(year, index) in period_year" :key="index" :label="year.title" :value="year.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Periodo" class="label-mt-0">
            <el-select v-model="form.period" :key="form.year">
              <el-option v-for="(period, index) in period_month" :key="index" :label="period.perTributario+' '+period.desEstado" :value="period.perTributario"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="label-mt-0">
            <el-button type="primary" @click="sendPeriod" :disabled="form.period == null"
              :loading="loading_send_period"
            >Aceptar</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="card-body border-bottom d-flex flex-wrap align-items-center" v-if="code_ticket !== null">
        <div class="mb-3" style="min-width: 45% ; max-width: 100% ;overflow-x: auto; white-space: nowrap;">
          <table class="table table-unstyled mb-0">
            <tr>
              <th>Año</th>
              <th>Periodo</th>
              <th>Ticket Actual</th>
              <th>Estado</th>
              <th class="ps-3">Página</th>
              <th></th>
            </tr>
            <tr>
              <td>{{ year }}</td>
              <td>{{ period }}</td>
              <td>{{ code_ticket }}</td>
              <td><span class="badge bg-secondary text-white" :class=" states_bg[status_ticket] "> {{ states[status_ticket] }} </span> </td>
              <td width="8%">
                <!-- <el-input v-model="page" label="Pagina" size="mini" type="number"></el-input> -->
                <el-input-number v-model="page"
                  controls-position="right"
                  size="mini"
                  :min="1"
                  style="width: 100px;"
                  @change="changePage"
                ></el-input-number>
              </td>
              <td class="text-right">
                
              </td>
            </tr>
          </table>
        </div>
        <div class=" ml-2">
          <el-button
                  type="primary"
                  @click="queryTicket"
                  :disabled="code_ticket == null"
                  class="bg-primary "
                  size="mini"
                  :loading="loading_query">
                  Consultar
                </el-button>
        </div>
        <div v-if="tray_id" class="mt-3 ml-2">
          
                <el-button v-if="tray_id"
                  type="info"
                  class="mt-2"
                  @click="getDataTicket"
                  size="mini"
                  :loading="loading_get_data_ticket">
                  Ver listado
                </el-button>
                <el-button v-if="tray_id"
                  native-type="button"
                  size="mini"
                  class="mt-2"
                  type="success"
                  @click="downloadExcel"
                  :loading="loading_download_excel"
                >
                  <i class="fa fa-file-excel"></i> Exportar
                </el-button>

                <br>
                <div>
                  <el-checkbox label="Código tipo de documento"
                  v-model="code_type_document"
                ></el-checkbox>
                <el-tooltip content='Boton "Exportar": Al exportar el tipo de documento mostrará el código'
                  placement="top"
                >
                  <i class="fa fa-info-circle"></i>
                </el-tooltip>
                </div>
                
        </div>
        <div v-if="tray_id" class="btn-group mt-2 mb-2 ml-2" >
                  <button
                      aria-expanded="false"
                      class="btn btn-danger btn-sm dropdown-toggle"
                      data-toggle="dropdown"
                      type="button"
                  >
                      <i class="fa fa-download"></i> Exportar SIRE
                      <span class="caret"></span>
                  </button>

                  <div class="dropdown-menu" role="menu" style="top: 100%; left: 0; z-index: 1050;">
                      <a
                          class="dropdown-item text-1"
                          href="#"
                          @click.prevent="clickExportTxt()"
                      >.txt</a>
                      <a
                          class="dropdown-item text-1"
                          href="#"
                          @click.prevent="clickExportExcelSire()"
                      >.xlsx</a>
                  </div>
        </div>
        <div v-if="tray_id" class=" ml-2" >
          <el-button 
                            native-type="button"
                            size="mini"
                            type="success"
                            @click="downloadAccountExcel"
                            :loading="loading_download_excel"
                          >
                            <i class="fa fa-file-excel"></i> Exportar Reporte Contable
            </el-button>
      </div>
        
      </div>
      <div class="card-body">
        <div class="row" v-if="documents.length">
          <div class="col-12">
            <h5 class="font-bold">
              Página {{ page }}
              <el-tooltip placement="top-start">
                <div slot="content">
                  <strong>Rojo:</strong><br>
                  - Cuando la {{ type === 'sale' ? 'venta' : 'compra' }} traída por SIRE no se encuentra registrada en el sistema. <br>
                  - Cuando el total de la {{ type === 'sale' ? 'venta' : 'compra' }} traída por SIRE difiere del monto de la {{ type === 'sale' ? 'venta' : 'compra' }} registrada en el sistema. <br>
                  <strong>Negro:</strong><br>
                  - La {{ type === 'sale' ? 'venta' : 'compra' }} emitida en el sistema es igual a lo que se encuentra en SIRE.
                </div>
                <i class="fa fa-info-circle"></i>
              </el-tooltip>
            </h5>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th colspan="14"></th>
                <th colspan="4">Referencia del comprobante o Doc. original que se modifica</th>
              </tr>
              <tr>
                <th>Servicio
                  <el-tooltip placement="top-start">
                    <div slot="content">
                      {{ name_service }}: {{ type === 'sale' ? 'Ventas' : 'Compras' }} emitidas en el sistema.  <br>
                      SUNAT: {{ type === 'sale' ? 'Ventas' : 'Compras' }} que están en el SIRE de SUNAT.
                    </div>
                    <i class="fa fa-info-circle"></i>
                  </el-tooltip>
                </th>
                <th>F. Emisión</th>
                <th>Tipo Documento</th>
                <th>Serie</th>
                <th>Número</th>
                <th>Número Doc. Identidad</th>
                <th>{{ user_type }}</th>
                <th>Base imponible Gravada</th>
                <template v-if="type === 'sale'">
                    <th>Exonerada</th>
                    <th>Inafecta</th>
                </template>
                <template v-else>
                    <th style="white-space: nowrap;" colspan="2">Exonerado / Inafecto</th>
                </template>
                <th>IGV</th>
                <th>Total</th>
                <th>Tipo de Cambio</th>
                <th>Moneda</th>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Serie</th>
                <th>Nro. Comp.</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="documents.length">
                <tr v-for="item in documents" :class="verifyBgRow(item)">
                  <td :class="[ item.service === 'SUNAT' ? 'text-success' : 'text-primary' ]">{{ item.service }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.document_type }}</td>
                  <td>{{ item.serie }}</td>
                  <td>{{ item.number }}</td>
                  <td>{{ item.number_company }}</td>
                  <td>
                    {{ item.name_company }}
                  </td>

                  <td>{{ item.total_taxed }}</td>
                  <template v-if="item.total_valor_ng !== undefined && item.total_valor_ng !== null">
                      <td colspan="2" class="text-center">
                          {{ item.total_valor_ng }}
                      </td>
                  </template>
                  <template v-else>
                      <td >
                           {{ item.total_exonerated  }}
                      </td>
                      <td >
                           {{ item.total_unaffected  }}
                      </td>
                  </template>
                  <td>{{ item.total_igv }}</td>
                  <td>{{ item.total }}</td>
                  <td>{{ item.exchange_rate_sale }}</td>
                  <td>{{ item.currency_type_id }}</td>
                  <td>{{ item.affected_document ? item.affected_document.date_of_issue : '' }}</td>
                  <td>{{ item.affected_document ? item.affected_document.document_type_id : '' }}</td>
                  <td>{{ item.affected_document ? item.affected_document.series : '' }}</td>
                  <td>{{ item.affected_document ? item.affected_document.number : '' }}</td>
                </tr>
                <tr v-for="item in total_documents">
                  <td colspan="7"></td>
                  <td colspan="4">
                    <span class="font-bold">
                      {{ `${item.service} (${item.count})` }}
                    </span>
                  </td>
                  <td>
                    <span class="font-bold">
                      {{ item.total }}
                    </span>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td class="text-center" colspan="8">No se encontraron resultados</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card-footer">
        <div class="row d-flex align-items-end">
          <div class="col-6">
            <el-button
              type="success"
              class=""
              :disabled="documents.length <= 0"
              @click="sendAccept"
              :loading="loading_accept">
              Aceptar Propuesta
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {setSireStorage, updateFieldToCompany, getStorageSireCompany} from './utils/sire_storage.js'

export default {
  components: {},
  data() {
    return {
      resource: 'sire',
      type: 'sale',
      period_year: [],
      period_month: [],
      form: {},
      year:null,
      period: null,
      tray_id: null,
      code_ticket: null,
      states: {
        '00': 'No solicitado',
        '01': 'Cargado (solicitado)',
        '02': 'Validando Archivo (en proceso)',
        '03': 'Procesado con Errores',
        '04': 'Procesado sin errores (concluido)',
        '05': 'En proceso',
        '06': 'Terminado'
      },
      states_bg: {
        '00': 'bg-info',      //enviado
        '01': 'bg-secondary', //registrado
        '02': 'bg-secondary', //registrado
        '03': 'bg-danger',    //anulado
        '04': 'bg-secondary', //registrado
        '05': 'bg-warning',   //por anular
        '06': 'bg-success'    //enviado
      },
      status_ticket: '01',
      period_current: null,
      page: 1,
      filename: null,
      loading_query: false,
      loading_data: false,
      documents: [],
      loading_accept: false,
      loading_send_period : false,
      loading_get_data_ticket: false,
      loading_download_excel: false,
      name_service: process.env.MIX_SYSTEM_NAME_IN_SIRE,
      code_type_document: false,
    }
  },
  created() {
    this.setType()
    this.setStorageDefault()
    this.getPeriods()
    this.getData()
  },
  computed: {
    total_documents() {
      const services = ['SUNAT', process.env.MIX_SYSTEM_NAME_IN_SIRE]

      const result = services.map(service => {
        const count = this.documents.reduce((total, item) => {
          return item.service === service ? total + 1 : total
        }, 0)

        const total = this.documents.reduce((total, item) => {
          return item.service === service ? total + parseFloat(item.total) : total
        }, 0)

        return {
          service,
          count,
          total: total.toFixed(2)
        }
      })

      return result
    },
    user_type() {
      return this.type === 'sale' ? 'Cliente' : 'Proveedor'
    }
  },
  methods: {
    setType() {
      this.type = window.location.href.split('/').pop()
    },
    setStorageDefault() {
      setSireStorage()
    },
    getPeriods() {
      this.$http.get(`/${this.resource}/${this.type}/tables`)
        .then((response)=>{
          this.setPeriodsData(response.data.data)
        })
        .catch((error)=>{
          console.error(error)
        })
    },
    setPeriodsData(data) {
      this.period_year = data.map(period => {
        return {
          id: period.numEjercicio,
          title: period.numEjercicio+' - '+period.desEstado,
          periods: period.lisPeriodos
        }
      })
    },
    setPeriods() {
      let record = this.period_year.find(item => item.id == this.form.year)
      this.period_month = record.periods
      this.$set(this.form, 'period', null)
    },
    sendPeriod() {
      this.loading_send_period = true
      this.documents = []
      this.period_current = this.form.period
      this.$http.get(`/${this.resource}/${this.type}/${this.form.period}/ticket`)
        .then((response)=>{
          this.code_ticket = response.data.data.numTicket
          this.period = this.form.period
          this.year = this.form.year
          this.status_ticket = '00'
          this.tray_id = null
          updateFieldToCompany(this.type, 'year', this.form.year)
          updateFieldToCompany(this.type, 'period', this.form.period)
          updateFieldToCompany(this.type, 'ticket', this.code_ticket)
          updateFieldToCompany(this.type, 'status', this.status_ticket)
          updateFieldToCompany(this.type, 'tray_id', null)
          this.loading_send_period = false
          this.$message.success('Ticket generado exitosamente')
        })
        .catch((error)=>{
          this.loading_send_period = false
          console.error(error)
        })
    },
    getData() {
      let company = getStorageSireCompany()
      this.code_ticket = company[this.type]['ticket']
      this.status_ticket = company[this.type]['status']
      this.year = company[this.type]['year']
      this.period = company[this.type]['period']
      this.tray_id = company[this.type]['tray_id']
      if(this.code_ticket) {
        this.period_current = company[this.type]['period']
      }
    },
    queryTicket() {
      // this.documents = []
      // this.loading_query = true
      // let params = {
      //   period: this.period_current,
      //   page: this.page,
      //   ticket: this.code_ticket
      // }
      // this.$http.post(`/${this.resource}/${this.type}/query`, params)
      //   .then((response)=>{
      //     this.loading_query = false
      //     if(response.data.success){
      //       this.$message.success('Información obtenida exitosamente')
      //       this.status_ticket = response.data.data.status_code
      //       this.documents = response.data.data.documents
      //       updateFieldToCompany(this.type, 'status', this.status_ticket)
      //     } else if(response.data.code === 200) {
      //       this.$message({
      //         message: response.data.message,
      //         type: 'warning'
      //       })
      //     }
      //   })
      //   .catch((error)=>{
      //     this.loading_query = false
      //     console.error(error)
      //   })


      // #######################
      this.changePage()

      this.loading_query = true
      const params = {
        period: this.period_current,
        page: this.page,
        ticket: this.code_ticket
      }
      this.$http.post(`/${this.resource}/${this.type}/query`, params)
        .then((response) => {
          this.loading_query = false
          if(response.data.success) {
            this.$message.success('Información obtenida exitosamente')
            this.status_ticket = response.data.data.status_code
            // this.documents = response.data.data.documents
            updateFieldToCompany(this.type, 'status', this.status_ticket)

            const { download_tray_id } = response.data.data
            updateFieldToCompany(this.type, 'tray_id', download_tray_id)
            this.tray_id = download_tray_id

            // if (response.data.data.download_tray_id) {
            //   console.log('Subscribiéndome a tray', response.data.data.download_tray_id)
            //   this.subscribeTray(response.data.data.download_tray_id) // ← escucha evento en tiempo real
            // } else {
            //   console.warn('No hubo tray_id, no me suscribo')
            // }
          } else if(response.data.code === 200) {
            this.$message({
              message: response.data.message,
              type: 'warning'
            })
          }
        })
        .catch(() => {
          this.loading_query = false
          this.$message.error('Error al obtener información')
        })
    },
    diffRows({ row, rowIndex }) {
      if (rowIndex < this.documents.length - 1) {
        const currentRow = row;
        const nextRow = this.documents[rowIndex + 1];

        if (
          currentRow.number == nextRow.number &&
          currentRow.serie == nextRow.serie &&
          currentRow.total !== nextRow.total
        ) {
          return 'bg-danger';
        }
      }
      return null;
    },
    sendAccept() {
      this.loading_accept = true
      // let sire_period = localStorage.getItem(this.type+'_sire_period')
      let period = null
      const data_sire = localStorage.getItem('sire')
      if (data_sire) {
        const sire = JSON.parse(data_sire)
        if (sire.length) {
          period = this.type == 'sale' ? sire[0].sale.period :
                      sire[0].purchase.period
        }
      }

      this.$http.get(`/${this.resource}/${this.type}/${period}/accept`)
        .then((response)=>{
          if(response.data.success){
            // console.log(response.data)
            this.$message.success('Propuesta enviada exitosamente')
          } else {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: 'error',
              message: response.data.message
            })
          }
          this.loading_accept = false
        })
        .catch((error)=>{
          this.loading_accept = false
          console.error(error)
        })
    },

    async getDataTicket() {
      if (!this.tray_id) {
        this.$message({
          message: 'Primero debe consultar el ticket',
          type: 'warning'
        })
        return
      }

      this.loading_get_data_ticket = true
      try {
        const response = await this.$http.get(`/${this.resource}/get_data_ticket/${this.tray_id}`)
        const { success, data, message } = response.data
        if (success) {
          this.$message.success(message)
          this.documents = data
        } else {
          this.$message.error(message)
          this.documents = []
        }
      } catch (error) {
        console.error(error)
        this.documents = []
      } finally {
        this.loading_get_data_ticket = false
      }
    },

    verifyBgRow(item) {
      const exists_label = item.hasOwnProperty('label')
      if (!exists_label) {
        return ''
      }
      return item.label === 'DANGER' ? 'text-danger' : ''
    },

    changePage() {
      updateFieldToCompany(this.type, 'tray_id', null)
      let company = getStorageSireCompany()
      this.tray_id = company[this.type]['tray_id']
      this.documents = []
    },

    subscribeTray(trayId) {
      window.Echo.private(`sire.tray.${trayId}`)
        .subscribed(() => console.log('✅ Subscribed a', `sire.tray.${trayId}`))
        .listen('.SireTrayFinished', async (e) => {
          console.log('SireTrayFinished')
          console.log(e)
          this.documents = e.documents
        })
    },

    async downloadExcel() {
      try {
        this.loading_download_excel = true
        const response = await this.$http.get(`/${this.resource}/get_data_ticket/${this.tray_id}`)
        const { success, message } = response.data
        if (success) {
          this.$message.success(message)
          setTimeout(() => {
            window.open(`/sire/download_excel/${this.type}/${this.tray_id}/${this.code_type_document}`, '_blank')
          }, 1200)
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading_download_excel = false
      }
    },

    clickExportTxt() {
      if (!this.tray_id) {
        this.$message.warning('Primero debe consultar el ticket')
        return
      }
      window.open(`/sire/download_txt/${this.tray_id}`, '_blank')
    },

    clickExportExcelSire() {
      if (!this.tray_id) {
        this.$message.warning('Primero debe consultar el ticket')
        return
      }
      window.open(`/sire/download_excel_sire/${this.tray_id}`, '_blank')
    },
    downloadAccountExcel() {
      if (!this.tray_id) {
        this.$message.warning('Primero debe consultar el ticket')
        return
      }
      
      const params = `tray_id=${this.tray_id}&type=${this.type}&period=${this.period}`
      window.open(`/account/format/download-sire?${params}`, '_blank')
    },
  }
}
</script>

<style scope>
.label-mt-0, .label-mt-0 label {
  margin-top: 0px;
  margin-bottom: 0px !important;
}
.el-button--mini {
  padding: 7px 15px !important;
}
</style>


// WEBPACK FOOTER //
// resources/js/views/tenant/sire/index.vue